[
  {
    "id": 0,
    "name": "all",
    "enName": "All",
    "emoji": ""
  },
  {
    "id": 1,
    "name": "burger",
    "enName": "Burger",
    "emoji": "🍔"
  },
  {
    "id": 2,
    "name": "hotdog",
    "enName": "Hotdog",
    "emoji": "🌭"
  },
  {
    "id": 3,
    "name": "pizza",
    "enName": "Pizza",
    "emoji": "🍕"
  },
  {
    "id": 4,
    "name": "toast",
    "enName": "Toast",
    "emoji": "🥪"
  },
  {
    "id": 5,
    "name": "chicken",
    "enName": "Chicken",
    "emoji": "🍗"
  },
  {
    "id": 6,
    "name": "pasta",
    "enName": "Pasta",
    "emoji": "🥘"
  },
  {
    "id": 7,
    "name": "doner",
    "enName": "Doner",
    "emoji": "🌯"
  },
  {
    "id": 8,
    "name": "salad",
    "enName": "Salad",
    "emoji": "🥗"
  },
  {
    "id": 9,
    "name": "sandwich",
    "enName": "Sandwich",
    "emoji": "🌮"
  },
  {
    "id": 10,
    "name": "tacos",
    "enName": "Tacos",
    "emoji": "🌯"
  },
  {
    "id": 11,
    "name": "healthy",
    "enName": "Healthy",
    "emoji": "🥙"
  },
  {
    "id": 12,
    "name": "pharmacy",
    "enName": "Pharmacy",
    "emoji": "💊"
  },
  {
    "id": 13,
    "name": "flowers",
    "enName": "Flowers",
    "emoji": "💐"
  },
  {
    "id": 14,
    "name": "sweets",
    "enName": "Sweets",
    "emoji": "🍰"
  },
  {
    "id": 15,
    "name": "sushi",
    "enName": "Sushi",
    "emoji": "🍣"
  },
  {
    "id": 16,
    "name": "drinks",
    "enName": "Drinks",
    "emoji": "🥤"
  }
]
